package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordPersonType(private val literal: String) : IEnumType {
	孕妇("孕妇"),
	产妇("产妇"),
	非孕产妇("非孕产妇");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_person_type"}
	override fun getLiteral(): String {return literal}
}
